import { Component } from '@angular/core';
import { OktaAuthService } from '@okta/okta-angular';
import { exhaustMap, switchMap, tap } from 'rxjs/operators';
import { GiftCardAlertService } from './gift-card-alert/gift-card-alert-service';
import { GiftCardAlert } from './gift-card-alert/model/gift-card-alert';
import { CompanyInfo } from './info/company/company-info';
import { CompanyInfoService } from './info/company/company-info-service';
import { EventSubscriber } from './util/event/event-subscriber';
import { PriceChangeService } from './inventory/price-change/price-change-service';
import { Observable, timer } from 'rxjs';
import { PriceChangeStatus } from './inventory/price-change/model/price-change';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent extends EventSubscriber<GiftCardAlert[]>{
  public isAuthenticated!: boolean;
  public companyInfo!: CompanyInfo;
  public giftCardAlerts = 0;
  public priceChangesCount!: Number;

  public constructor(
    companyInfoService: CompanyInfoService,
    priceChangeService: PriceChangeService,
    private giftCardAlertService: GiftCardAlertService,
    private oktaAuthService: OktaAuthService,
  ) {
    super(
      subscriber => this.giftCardAlertService.getEvents(subscriber),
      subscriber => this.giftCardAlertService.disposeEventsSubscription(subscriber),
    );

    timer(0, 5000)
      .pipe(switchMap(_ => priceChangeService.countByStatus([PriceChangeStatus.TO_PROCESS])))
      .pipe(tap(priceChangesCount => this.priceChangesCount = priceChangesCount))
      .subscribe();

    oktaAuthService.$authenticationState
      .pipe(tap(isAuthenticated => this.isAuthenticated = isAuthenticated))
      .pipe(switchMap(_ => companyInfoService.getCompanyInfo()))
      .pipe(tap(companyInfo => this.companyInfo = companyInfo))
      .pipe(switchMap(_ => giftCardAlertService.refresh()))
      .pipe(tap(giftCardAlerts => this.giftCardAlerts = giftCardAlerts.length))
      .pipe(switchMap(_ => this.subscribe()))
      .pipe(tap(giftCardAlerts => this.giftCardAlerts = giftCardAlerts.length))
      .subscribe();
  }

  async logout() {
    await this.oktaAuthService.signOut({ postLogoutRedirectUri: window.location.origin + '/login/logout-success' });
  }
}
